import { Injectable } from '@angular/core';

@Injectable()
export class DataService {
  changeData: boolean;
  constructor(){

  }
}